import { TripType } from '@rome/response/page/v4/travel/flights/v1/enums/TripType';
import { SearchWidgetActions } from 'actions/TravelActions/SearchWidgetActions';
import get from 'lodash/get';
import { VALIDATIONS } from 'constants/TravelConstants';
const fieldValidation = (data) => {
    const tripType = data.selectedTripType;
    let isValid = true;
    const journeyValidation = {};
    data.journeyList.length &&
        data.journeyList.forEach(journey => {
            const originAirportCode = get(journey, 'origin.value.airportCode');
            const destAirportCode = get(journey, 'dest.value.airportCode');
            let destination = '';
            let origin = '';
            let endDate = '';
            // When destination city is empty
            if (!journey.dest || journey.dest.isEmpty) {
                destination = VALIDATIONS.DEST_EMPTY;
            }
            // when destination city is not selected from suggestions, isDirty would be true and this error would show
            else if (journey.dest.isDirty && !journey.dest.isEmpty) {
                destination = VALIDATIONS.CITY_SUGGESTION;
            }
            // origin and destination are same.
            else if (originAirportCode === destAirportCode) {
                destination = VALIDATIONS.DIFF_ORIGIN_DEST;
            }
            // origin city input field is empty
            if (!journey.origin || journey.origin.isEmpty) {
                origin = VALIDATIONS.ORIGIN_EMPTY;
            }
            // origin city is not selected from suggestions.
            else if (journey.origin.isDirty && !journey.origin.isEmpty) {
                origin = VALIDATIONS.CITY_SUGGESTION;
            }
            // Round trip is selected but without return date.
            if (!journey.journeyEndDate && tripType === TripType.ROUND_TRIP) {
                endDate = VALIDATIONS.RETURN_DATE_EMPTY;
            }
            // if any error present, mark isValid false.
            if (destination || origin || endDate) {
                isValid = false;
                const key = journey.requestKey || '';
                journeyValidation[key] = {
                    destination,
                    origin,
                    endDate
                };
            }
        });
    //TODO: @Milan to add travellerValidation here
    return { isValid, journeyValidation };
};
const defaultState = {
    isValid: false
};
export default function SearchWidgetValidation(state = defaultState, action) {
    switch (action.type) {
        case SearchWidgetActions.LOCAL_VALIDATION:
            return fieldValidation(action.data);
        case SearchWidgetActions.CLEAR_VALIDATION:
            return defaultState;
        default:
            return state;
    }
}
